/**
 * Synthetic room-POI builder (E-12e) — THE constructor for the RVT room-navigation
 * payload consumed by App.handlePOINavigation → the AutodeskViewer focusedPOI effect.
 *
 * Both the LocationsPage "3D" room button and the AutodeskViewer browser-pane "Room"
 * button hand-built this object; drift between the two copies meant the same room could
 * navigate differently depending on which button was used. Field semantics preserved
 * from both originals: custom_data only when a dbId exists; isCustomRoom defaults false;
 * geometry_polygon passes through for custom rooms.
 */

export interface SyntheticRoomPoiInput {
  id: string | number;
  name: string;
  elevation?: number;
  height?: number;
  dbId?: number | string | null;
  sourceFile?: string | null;
  isCustom?: boolean;
  geometryPolygon?: any;
}

export const buildSyntheticRoomPoi = (input: SyntheticRoomPoiInput): any => ({
  id: input.id,
  name: input.name,
  coordinates: { x: 0, y: 0, z: 0 },
  elevation: input.elevation,   // Floor elevation for room geometry
  height: input.height,         // Room height for space geometry
  ifc_source_file: input.sourceFile || undefined,
  custom_data: input.dbId != null ? {
    rvt: {
      rvtElementDbId: Number(input.dbId),
      ...(input.sourceFile ? { originalFileName: input.sourceFile } : {})
    }
  } : undefined,
  properties: {
    type: 'Spaces',
    isCustomRoom: input.isCustom || false
  },
  geometry_polygon: input.geometryPolygon,
  skipInfoPanel: true // Only highlight, don't open ElementInfoPanel
});
